import usertoken from './usertoken';
import apikey from './apikey';
import changepassword from './changepassword';
import setpassword from './setpassword';

export default { usertoken, apikey, changepassword, setpassword };
